import MailboxCalendarConfiguration from 'owa-service/lib/contract/MailboxCalendarConfiguration';
import { getCalendarConfiguration } from 'owa-calendar-configuration';
import { orchestrator } from 'satcheljs';
import { addToWeatherList } from '../data/actions/weatherActions';
import WeatherError from '../data/store/schema/WeatherError';
import { setWeatherError, setWeatherList } from '../data/actions/weatherMutatorActions';
import getWeatherOptions from '../data/store/store';

orchestrator(addToWeatherList, async actionMessage => {
    const { weatherItem } = actionMessage;
    const store = getWeatherOptions();
    if (store.weatherLocations == null) {
        let calendarConfiguration: MailboxCalendarConfiguration = getCalendarConfiguration();
        setWeatherList(calendarConfiguration.WeatherLocations.slice());
    }
    const weatherList = store.weatherLocations.slice();
    // prevent adding duplicate locations
    if (!weatherList.some(location => location.LocationId === weatherItem.LocationId)) {
        weatherList.unshift(weatherItem);
        setWeatherList(weatherList);
    } else {
        setWeatherError(WeatherError.AddingExistingLocation, weatherItem.Name);
    }
});
